import {
  Component,
  input,
  output,
  HostListener,
  ElementRef,
  inject,
  computed,
  OnInit,
  signal,
  LOCALE_ID,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NotificationType } from '../../admin-dashboard-component/header/header.model';
import { NotificationService } from '../../../services/notifications/notifications.service';
import { WebsocketService } from '../../../services/notifications/WebSocketService';
import { timeAgo } from './utils/timeago';

@Component({
  selector: 'app-notifications-dropdown',
  imports: [RouterLink, CommonModule],
  templateUrl: './notifications-dropdown.html',
  styleUrl: './notifications-dropdown.scss',
})
export class NotificationsDropdown implements OnInit {
  private notificationService = inject(NotificationService);
  private websocketService = inject(WebsocketService);
  private locale = inject(LOCALE_ID);
  notifications = signal<NotificationType[]>([]);
  isOpen = input<boolean>(false);
  closeRequested = output<void>();
  // markAllReadRequested = output<void>();

  private elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.loadNotifications();
    this.websocketService.connect('1');
    this.websocketService.notifications.subscribe((data: any) => {
      console.log('new notification: ', data);
      const newNotif = {
        //   // map data to NotificationType
        id: data.message.eventId,
        subjectEn: data.message.subjectEn,
        subjectAr: data.message.subjectAr,
        bodyEn: data.message.bodyEn,
        bodyAr: data.message.bodyAr,
        isRead: false,
        createdOn: timeAgo(data.createdOn),
      };

      this.notifications.update((list) => [newNotif, ...list]);
    });
  }

  loadNotifications() {
    this.notificationService.getAllNotifications().subscribe({
      next: (res) => {
        const handledRes = res.list.map((n) => {
          return { ...n, createdOn: timeAgo(n.createdOn) };
        });

        // console.log('handleRes: ', handledRes);
        this.notifications.set(handledRes);
      },
      error: () => {},
    });
  }

  unreadCount = computed(() => {
    return this.notifications().filter((n) => !n.isRead).length;
  });

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isOpen() && !this.elementRef.nativeElement.contains(event.target)) {
      this.closeRequested.emit();
    }
  }

  onMarkAsRead(notificationId: number) {
    const notification = this.notifications().find((n) => n.id === notificationId);
    if (notification && notification.isRead) {
      return;
    }
    this.notificationService.markNotificationAsRead(notificationId).subscribe({
      next: () => {
        if (notification && !notification.isRead) {
          notification.isRead = true;

          this.notifications.set([...this.notifications()]);
        }
      },
      error: () => {},
    });
  }

  // onMarkAllRead() {
  //   this.markAllReadRequested.emit();
  // }

  onViewAll() {
    this.closeRequested.emit();
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
